import { render, staticRenderFns } from "./item-child.vue?vue&type=template&id=2d84969a&scoped=true"
import script from "./item-child.vue?vue&type=script&lang=js"
export * from "./item-child.vue?vue&type=script&lang=js"
import style0 from "./item-child.vue?vue&type=style&index=0&id=2d84969a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d84969a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d84969a')) {
      api.createRecord('2d84969a', component.options)
    } else {
      api.reload('2d84969a', component.options)
    }
    module.hot.accept("./item-child.vue?vue&type=template&id=2d84969a&scoped=true", function () {
      api.rerender('2d84969a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/organization/newRole/roleCollapse/item-child.vue"
export default component.exports